export default __webpack_public_path__ + "static/media/morph_logo_light_alt_2.d8a23eb8.svg";